import areNotificationsEnabled from 'owa-notifications-settings/lib/selectors/areNotificationsEnabled';
import originalAreNotificationsEnabledForAccount from 'owa-notifications-settings/lib/selectors/areNotificationsEnabledForAccount';
import type { MailboxInfo } from 'owa-client-types';
import { getIsOpx } from '../selectors/getIsOpx';

/**
 * In OWA/Monarch: Returns true if notifications are enabled globally and for the specified account.
 * In OPX (Win32): Returns true always, as notifications are always enabled.
 *
 * This is a wrapper around the existing areNotificationsEnabledForAccount selector to also check
 * if notifications are enabled globally. Ideally, that check should consider both conditions, but
 * to avoid breaking the (many) existing consumers, we introduce this new utility function.
 *
 * For OPX, there is no global notifications check (i.e. notifications cannot be disabled).
 * Notifications are *always* enabled.
 */
export function areNotificationsEnabledForAccount(mailboxInfo: MailboxInfo): boolean {
    return (
        getIsOpx() ||
        (originalAreNotificationsEnabledForAccount(mailboxInfo) && areNotificationsEnabled())
    );
}
